module.exports = __webpack_public_path__ + "img/cert-hightech.f59fda09.png";